<template>
	<div>
		<h2>Tenant Plan</h2>
		<div style="display: flex; flex-direction: column">
			<v-row>
				<v-col cols="12">
					<v-card>
						<v-tabs v-model="tab" background-color="rgb(0, 51, 102)" dark>
							<v-tab v-for="(tabHeader, index) in table" :key="index">{{ tabHeader.type }}</v-tab>
						</v-tabs>

						<v-tabs-items v-model="tab">
							<v-tab-item v-for="(tabItem, idx) in table" :key="idx">
								<v-card>
									<v-card-text>
										<v-simple-table>
											<template v-slot:default>
												<thead>
													<tr>
														<th>ID</th>
														<th>Name</th>
														<th>Experience Limit</th>
														<th v-if="tabItem.type === 'Exhibition'">User Limit</th>
														<th>Presentation Limit</th>
														<th>Room Limit</th>
														<th v-if="tabItem.type === 'Exhibition'">Booth Limit</th>
														<th></th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(plan, idxPlan) in tabItem.planList" :key="idxPlan">
														<td>{{ plan.id }}</td>
														<td>{{ plan.name }}</td>
														<td>{{ plan.experienceLimit }}</td>
														<td v-if="plan.type === 'Exhibition'">{{ plan.userLimit }}</td>
														<td>{{ plan.presentationLimit }}</td>
														<td>{{ plan.roomLimit }}</td>
														<td v-if="plan.type === 'Exhibition'">{{ plan.boothLimit }}</td>
														<td>
															<v-btn fab x-small @click="showEditPlan(plan)">
																<v-icon>mdi-pencil</v-icon>
															</v-btn>
															<v-btn fab x-small style="margin-left: 10px" @click="showDeletePlan(plan)">
																<v-icon>mdi-delete</v-icon>
															</v-btn>
														</td>
													</tr>

													<tr>
														<td :colspan="tabItem.type === 'Exhibition' ? 7 : 5"></td>
														<td>
															<v-btn fab x-small color="primary" @click="showAddPlan(tabItem.type)">
																<v-icon>mdi-plus</v-icon>
															</v-btn>
														</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
									</v-card-text>
								</v-card>
							</v-tab-item>
						</v-tabs-items>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<v-dialog v-model="dialogAdd.show" max-width="500">
			<v-form ref="addForm" v-model="dialogAdd.valid" @submit.prevent="addPlan()">
				<v-card>
					<v-card-title>Add New Plan</v-card-title>
					<v-card-text>
						<v-row class="d-flex">
							<v-col cols="12">
								<v-text-field v-model="dialogAdd.entity.name" :rules="fieldRules" label="Name"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogAdd.entity.experienceLimit" :rules="valueOnlyRules" label="Experience Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Exhibition'">
								<v-text-field v-model="dialogAdd.entity.userLimit" :rules="valueOnlyRules" label="User Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogAdd.entity.presentationLimit" :rules="valueOnlyRules" label="Presentation Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogAdd.entity.roomLimit" :rules="valueOnlyRules" label="Room Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Exhibition'">
								<v-text-field v-model="dialogAdd.entity.boothLimit" :rules="valueOnlyRules" label="Booth Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-select v-model="dialogAdd.entity.roomLibraryOption" :items="assignLibrary" label="Select Room Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.roomLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.roomLibraryTagList"
									:items="roomTagList"
									chips
									small-chips
									deletable-chips
									label="Select Room Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Exhibition'">
								<v-select v-model="dialogAdd.entity.boothBackgroundLibraryOption" :items="assignLibrary" label="Select Booth Background Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.boothBackgroundLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.boothBackgroundLibraryTagList"
									:items="boothBackgroundTagList"
									chips
									small-chips
									deletable-chips
									label="Select Booth Background Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Exhibition'">
								<v-select v-model="dialogAdd.entity.boothDesignLibraryOption" :items="assignLibrary" label="Select Booth Design Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.boothDesignLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.boothDesignLibraryTagList"
									:items="boothDesignTagList"
									chips
									small-chips
									deletable-chips
									label="Select Booth Design Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Exhibition'">
								<v-select v-model="dialogAdd.entity.leaderboardLibraryOption" :items="assignLibrary" label="Select Leaderboard Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.leaderboardLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.leaderboardLibraryTagList"
									:items="leaderboardTagList"
									chips
									small-chips
									deletable-chips
									label="Select Leaderboard Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-select v-model="dialogAdd.entity.frameLibraryOption" :items="assignLibrary" label="Select Frame Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.frameLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.frameLibraryTagList"
									:items="frameTagList"
									chips
									small-chips
									deletable-chips
									label="Select Frame Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
							<v-col cols="12" v-if="dialogAdd.entity.type === 'Clinic'">
								<v-select v-model="dialogAdd.entity.transitionLibraryOption" :items="assignLibrary" label="Select Transition Library"></v-select>
								<v-autocomplete
									v-if="dialogAdd.entity.transitionLibraryOption=='By Tags'"
									v-model="dialogAdd.entity.transitionLibraryTagList"
									:items="transitionTagList"
									chips
									small-chips
									deletable-chips
									label="Select Transition Library Tags"
									multiple
								></v-autocomplete>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="closeAddDialog()">Cancel</v-btn>
						<v-btn type="submit" :disabled="!dialogAdd.valid" color="primary">Save</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<v-dialog v-model="dialogEdit.show" max-width="500">
			<v-form ref="editForm" v-model="dialogEdit.valid" @submit.prevent="editPlan()">
				<v-card>
					<v-card-title>Edit Plan</v-card-title>
					<v-card-text>
						<v-row class="d-flex">
							<v-col cols="12">
								<v-text-field v-model="dialogEdit.entity.name" :rules="fieldRules" label="Name"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogEdit.entity.experienceLimit" :rules="valueOnlyRules" label="Experience Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12" v-if="dialogEdit.entity.type === 'Exhibition'">
								<v-text-field v-model="dialogEdit.entity.userLimit" :rules="valueOnlyRules" label="User Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogEdit.entity.presentationLimit" :rules="valueOnlyRules" label="Presentation Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field v-model="dialogEdit.entity.roomLimit" :rules="valueOnlyRules" label="Room Limit" type="number"></v-text-field>
							</v-col>
							<v-col cols="12" v-if="dialogEdit.entity.type === 'Exhibition'">
								<v-text-field v-model="dialogEdit.entity.boothLimit" :rules="valueOnlyRules" label="Booth Limit" type="number"></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="closeEditDialog()">Cancel</v-btn>
						<v-btn type="submit" :disabled="!dialogEdit.valid" color="primary">Save</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<v-dialog v-model="dialogDelete.show" max-width="500">
			<v-card>
				<v-card-title>Delete Tenant Plan</v-card-title>
				<v-card-text class="px-5">Are you sure you want to delete {{ dialogDelete.entity.name }} plan?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDelete.show = false">Cancel</v-btn>
					<v-btn color="accent" @click="deletePlan()">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
	data() {
		return {
			tab: null,
			tenantTypeList: [],
			table: [],
			dialogAdd: { show: false, valid: true, entity: {} },
			dialogEdit: { show: false, valid: true, entity: {} },
			dialogDelete: { show: false, entity: {} },
			fieldRules: [v => (!!v && /.*[^ ].*/.test(v)) || "This field is required"],
			valueOnlyRules: [
				v => (!!v && /.*[^ ].*/.test(v)) || "This field is required",
				v => /^[1-9][0-9]*$/.test(v) || "Please input valid value only, and value must be higher than zero"
			],
			assignLibrary: ['All','By Tags'],
			roomTagList: [],
			boothBackgroundTagList: [],
			boothDesignTagList: [],
			leaderboardTagList: [],
			frameTagList: []
		};
	},
	mounted() {
		this.listTenantType();
		this.listRoomTag();
		this.listBoothBackgroundTag();
		this.listBoothDesignTag();
		this.listLeaderboardTag();
		this.listFrameTag();
		this.listTransitionTag();
	},
	methods: {
		naon(isi) {
			console.log(isi);
		},
		listRoomTag() {
			axios.get("/system/roomlibrary/tag/list").then(response => {
				this.roomTagList = response.data;
			});
		},
		listBoothBackgroundTag() {
			axios.get("/system/boothbackgroundlibrary/tag/list").then(response => {
				this.boothBackgroundTagList = response.data;
			});
		},
		listBoothDesignTag() {
			axios.get("/system/layout/tag/list").then(response => {
				this.boothDesignTagList = response.data;
			});
		},
		listLeaderboardTag() {
			axios.get("/system/leaderboardlibrary/tag/list").then(response => {
				this.leaderboardTagList = response.data;
			});
		},
		listFrameTag() {
			axios.get("/system/frame/tag/list").then(response => {
				this.frameTagList = response.data;
			});
		},
		listTransitionTag() {
			axios.get("/system/transitionlibrary/tag/list").then(response => {
				this.transitionTagList = response.data;
			});
		},
		listTenantType() {
			this.table = [];
			axios.get("/system/enumeration/membership/type/list").then(response => {
				this.tenantTypeList = response.data;
				axios.get("/system/tenantplan/list").then(response => {
					this.tenantTypeList.forEach(type => {
						let planType = { type: type };
						planType.planList = response.data.filter(x => {
							return x.type == type;
						});
						this.table.push(planType);
					});
				});
			});
		},
		showAddPlan(tenantType) {
			this.dialogAdd.entity = { type: tenantType };
			this.dialogAdd.show = true;
		},
		showEditPlan(plan) {
			this.dialogEdit.entity = Object.assign({}, plan);
			this.dialogEdit.show = true;
		},
		showDeletePlan(plan) {
			this.dialogDelete.entity = Object.assign({}, plan);
			this.dialogDelete.show = true;
		},
		addPlan() {
			axios
				.post("/system/tenantplan/add", {
					entity: this.dialogAdd.entity
				})
				.then(response => {
					this.listTenantType();
					this.dialogAdd.show = false;
					this.resetForms();
				})
				.catch(() => {});
		},
		editPlan() {
			axios
				.post("/system/tenantplan/edit", {
					entity: this.dialogEdit.entity
				})
				.then(response => {
					this.listTenantType();
					this.dialogEdit.show = false;
					this.resetForms();
				})
				.catch(() => {});
		},
		deletePlan() {
			axios
				.post("/system/tenantplan/delete", {
					id: this.dialogDelete.entity.id
				})
				.then(response => {
					this.listTenantType();
					this.dialogDelete.show = false;
					this.dialogDelete.entity = {};
				})
				.catch(error => {
					this.dialogDelete.show = false;
					this.dialogDelete.entity = {};
				});
		},
		closeAddDialog() {
			this.dialogAdd.show = false;
			this.dialogAdd.entity = {};
			this.resetForms();
		},
		closeEditDialog() {
			this.dialogEdit.show = false;
			this.dialogEdit.entity = {};
			this.resetForms();
		},
		resetForms() {
			if (this.$refs.addForm) {
				this.$refs.addForm.reset();
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.reset();
			}
		}
	}
};
</script>